"use client"

import React from 'react'
import { commonErrorsData } from './Data/CommonErrorsData'
import { useMobileContext } from './MobileContext'
import { Card, Typography, Collapse, Tabs } from 'antd'
import { useTranslation } from 'react-i18next'

const { Title, Paragraph, Text } = Typography
const { TabPane } = Tabs

const CommonErrors: React.FC = () => {
  const isMobile = useMobileContext()
  const { t } = useTranslation()

  return (
    <Card className={!isMobile ? 'p-6' : 'p-2'}>
      <Title level={2}>{t(commonErrorsData.title)}</Title>
      
      <div className="mt-6">
        {commonErrorsData.errors.map((error, index) => (
          <Collapse
            className="mb-4"
            key={index}
            items={[
              {
                key: '1',
                label: <span className="font-medium">{t(error.error)}</span>,
                children:
                  typeof error.details === 'string' ? (
                    <Paragraph className="whitespace-pre-line">{t(error.details)}</Paragraph>
                  ) : (
                    <Tabs defaultActiveKey="ios">
                      <TabPane tab="iOS" key="ios">
                        <Paragraph className="whitespace-pre-line">{t(error.details.iOS)}</Paragraph>
                      </TabPane>
                      <TabPane tab="Android" key="android">
                        <Paragraph className="whitespace-pre-line">{t(error.details.Android)}</Paragraph>
                      </TabPane>
                    </Tabs>
                  ),
              },
            ]}
          />
        ))}
      </div>
    </Card>
  )
}

export default CommonErrors